import React from "react";

export function Input({ placeholder, value, onChange, className }) {
  return (
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`border p-2 rounded-md w-full ${className}`}
    />
  );
}
